import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2c2c2c', // Dark grey
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f59f1f', // Investcorp orange/gold
      contrastText: '#2c2c2c',
    },
    background: {
      default: '#ffffff', // White background
      paper: '#f8f9fa',
    },
    text: {
      primary: '#2c2c2c',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Satoshi", sans-serif',
    h1: {
      color: '#2c2c2c',
    },
    h2: {
      color: '#2c2c2c',
    },
    h3: {
      color: '#2c2c2c',
    },
    h4: {
      color: '#2c2c2c',
    },
    h5: {
      color: '#2c2c2c',
    },
    h6: {
      color: '#2c2c2c',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#2c2c2c',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(44, 44, 44, 0.1)',
          border: '1px solid #e0e0e0',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#2c2c2c',
          color: '#ffffff',
        },
        colorSecondary: {
          backgroundColor: '#f59f1f',
          color: '#2c2c2c',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);